<template>
  <div class="links">
    <z-title>ネット販売</z-title>
    <div class="rows">
      <p class="word block-word">オンライン販売は準備中です</p>
      <!-- <p
        v-for="(item, index) in links"
        class="row"
        :key="index"
      >
        <img :src="item.url" alt="" />
      </p> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'index',
  data () {
    const {
      future: {
        link1,
        link2,
        link3,
        link4
      }
    } = this.$images
    return {
      links: [
        { url: link1 },
        { url: link2 },
        { url: link3 },
        { url: link4 }
      ]
    }
  }
}
</script>

<style lang="less" scoped>
.links{
  display: flex;
  flex-direction: column;

  .word{
    font-weight: 400;
    font-size: 24px;
    color: #323232;
    margin-left: 51px;
    padding-left: 18px;
    position: relative;

    &.block-word{
      width: 1531px;
      height: 184px;
      flex-shrink: 0;
      justify-content: center;
      align-items: center;
      display: flex;
      background: #374475;
      border-radius: 10px;
      margin-left: 0;
      padding: 0;
      font-size: 36px;
      color: #e09d50;
    }
  }

  .rows{
    width: 1531px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-left: 192px;
    margin-top: 59px;

    .row{
      box-shadow: 0px 0px 18px 2px rgba(234,234,234,0.55);
      border-radius: 10px;
      overflow: hidden;

      img{
        transform: scale(1);
        transition: transform .1s linear;

        &:hover{
          transform: scale(1.2);
        }
      }
    }
  }
}
</style>
